module.exports = __webpack_public_path__ + "img/wave-square.cab6dfaf.svg";